"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = EADebugRow;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _noop2 = _interopRequireDefault(require("lodash/noop"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _EAPropTypes = _interopRequireDefault(require("../style/props/EAPropTypes"));
var tdDateStyle = {
  border: '1px dashed #999',
  textAlign: 'center'
};
var tdEventNameStyle = {
  border: '1px dashed #999',
  textAlign: 'center',
  cursor: 'pointer',
  textDecoration: 'underline'
};
var tdRelevantFieldsStyle = {
  border: '1px dashed #999',
  textAlign: 'center',
  maxWidth: '75%',
  overflow: 'auto'
};
function EADebugRow(_ref) {
  var trackRecord = _ref.trackRecord,
    onClick = _ref.onClick,
    relevantFieldsConfig = _ref.relevantFieldsConfig;
  var timestamp = trackRecord.timestamp,
    eventName = trackRecord.eventName;
  var relevantFieldsForThisEvent = relevantFieldsConfig[trackRecord.eventName] || [];
  var relevantFieldsStrings = [];
  relevantFieldsForThisEvent.forEach(function (fieldNameWithSchema) {
    var _fieldNameWithSchema$ = fieldNameWithSchema.split(':'),
      _fieldNameWithSchema$2 = (0, _slicedToArray2["default"])(_fieldNameWithSchema$, 2),
      schemaName = _fieldNameWithSchema$2[0],
      fieldName = _fieldNameWithSchema$2[1]; // "app_interactions:elementname" becomes 'app_interactions' and 'elementname'
    var relevantSchema = (trackRecord.snowplowContexts || []).find(function (schema) {
      return schema.schema.includes("/".concat(schemaName, "/jsonschema/"));
    });
    var data = relevantSchema && relevantSchema.data || {};
    var fieldValue = (0, _get2["default"])(data, fieldName);
    relevantFieldsStrings.push({
      fieldName: fieldName,
      fieldValue: fieldValue
    });
  });
  return /*#__PURE__*/_react["default"].createElement("tr", {
    className: "ekoanalytics-debug-row"
  }, /*#__PURE__*/_react["default"].createElement("td", {
    style: tdDateStyle
  }, new Date(timestamp).toLocaleTimeString()), /*#__PURE__*/_react["default"].createElement("td", {
    style: tdEventNameStyle,
    onClick: onClick || _noop2["default"]
  }, eventName), /*#__PURE__*/_react["default"].createElement("td", {
    style: tdRelevantFieldsStyle
  }, relevantFieldsStrings.map(function (sPair, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: "".concat(timestamp, "-rfs-").concat(index)
    }, /*#__PURE__*/_react["default"].createElement("b", null, sPair.fieldName), " = ", sPair.fieldValue, /*#__PURE__*/_react["default"].createElement("br", null));
  })));
}